import { lazy, Suspense } from "react";
import { Helmet } from "react-helmet-async";

import HeroSection from "./HeroSection";
const FeaturesSection = lazy(() => import("./FeaturesSection"));
const ModulesSection = lazy(() => import("./ModulesSection"));
const SecuritySection = lazy(() => import("./SecuritySection"));

const HealthcareLIMS = () => {
  return (
    <>
      <Helmet>
        <title>
          LIMS | Cloud-Based Laboratory Information Management System | Winglo
        </title>

        <meta
          name="description"
          content="Winglo Healthcare LIMS is a cloud-based Laboratory Information Management System designed for diagnostic labs and multi-center lab chains."
        />

        <meta
          name="keywords"
          content="Healthcare LIMS, Laboratory Information Management System, cloud LIMS software, diagnostic lab software, analyzer integration, lab automation system"
        />
      </Helmet>

      <HeroSection />

      <Suspense fallback={<div className="h-[400px]" />}>
        <FeaturesSection />
         <ModulesSection />
         <SecuritySection />
      </Suspense>
    </>
  );
};

export default HealthcareLIMS;
